
import React from 'react';

const Footer: React.FC = () => {
  return (
    <footer className="bg-stone-900 text-stone-500 py-12 border-t border-stone-800">
      <div className="max-w-7xl mx-auto px-4 flex flex-col md:flex-row justify-between items-center text-center md:text-left">
        <div className="mb-6 md:mb-0">
          <h3 className="text-white font-serif text-xl font-bold mb-1">Norm's Barber Shop</h3>
          <p className="text-xs uppercase tracking-[0.2em] font-bold text-stone-600">Established 1992</p>
        </div>
        
        <div className="flex flex-col items-center md:items-end">
          <p className="text-sm">&copy; {new Date().getFullYear()} Norm's Barber Shop. All rights reserved.</p>
          <p className="text-xs mt-1 text-stone-600">
            601 N Ridge Rd, Wichita, KS 67212 
            <span className="mx-2">|</span> 
            (316) 721-8600 <span className="mx-1">&</span> (316) 729-8303
          </p>
        </div>
      </div>
      <div className="mt-8 text-center">
        <div className="barber-pole h-1 w-24 mx-auto mb-4 opacity-30"></div>
      </div>
    </footer>
  );
};

export default Footer;
